// Tyler.API.Common.Interfaces.InfoCardActionType
export enum InfoCardActionType {
    Command = 0,
    Menu = 1,
    Icon = 2,
    MultiSelect = 3,
    MassUpdate = 4,
    Print = 5,
    LinkLabel = 6,
    Intent = 7
}
